import axios from "@/utils/axios";



export const getPostSummaryList = (data) => axios.post("/post/getPostSummaryList", data);
export const getPostList = (data) => axios.post("/post/getPostList", data);
export const getPostDetail = (data) => axios.post("/post/getPostDetail", data);
export const getCommonImage = (data) => axios.post("/post/getCommonImage", data);
export const thumbPlus = (data) => axios.post("/post/thumbPlus", data);


export const getCourseSummaryList = (data) => axios.post("/course/getCourseSummaryList", data);
export const getCourseList = (data) => axios.post("/course/getCourseList", data);
export const getCourseDetail = (data) => axios.post("/course/getCourseDetail", data);

